import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError, MASCOT } from "@/lib/api";
import { AuthShell, AuthField } from "@/components/AuthShell";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      login(data.user);
      toast.success(`Olá de novo, ${data.user.name}!`);
      navigate(data.user.role === "admin" ? "/admin" : "/painel");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Entrar"
      subtitle="Que bom te ver de volta!"
      mascot={MASCOT.tilt}
      footer={<>Não tem conta? <Link to="/#planos" className="text-[#f0791f] font-semibold">Assine um plano</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <AuthField label="E-mail" testid="login-email" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="voce@email.com" required />
        <AuthField label="Senha" testid="login-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Sua senha" required />
        <div className="text-right">
          <Link to="/esqueci-senha" className="text-sm text-[#c17f3e] hover:text-[#f0791f]" data-testid="login-forgot-link">Esqueci minha senha</Link>
        </div>
        <button type="submit" disabled={loading} className="btn-orange w-full py-3.5 rounded-full font-semibold disabled:opacity-60" data-testid="login-submit">
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </AuthShell>
  );
}
